import { cn } from '@pubstack/ui/utils/cn'
import { FunctionComponent, ReactNode } from 'react'
import { Icon } from '~/components/Icon'
import { WithClassName } from '~/types/utils'

type Props = WithClassName & { children?: ReactNode }

/**
 * The crown that marks something the account has not bought.
 *
 * One marker, everywhere it applies — the ad unit tabs a scope cannot open, a blocked rule section, a
 * locked catalog card, the upgrade dialog's own eyebrow — so the same glyph always means the same
 * thing. A padlock would not: locked says "you may not", and everything wearing this says "not yet".
 *
 * Not in the sidebar. A permanent crown beside a nav entry is an advert that never goes away; the
 * marker belongs where the reader has just asked for the thing.
 */
export const UpgradeChip: FunctionComponent<Props> = ({ className, children }) => (
  <span className={cn('text-king inline-flex shrink-0 items-center gap-1', className)}>
    <Icon name={'crown'} width={'14px'} height={'14px'} />
    {children}
  </span>
)
